<div style="width: 100%;" fxFlex="100" fxLayoutAlign.gt-md="center start" class="container" fxLayout="row"
    fxLayout.xs="column" fxLayoutGap="10px" [formGroup]="firstFormGroup">

    <div style="width: 100%;" *ngIf="subscriptionLoaded && accountLoaded">




        <div style="width: 100%;" *ngIf="showCheckoutSection" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px"
            [class.full-width-checkout]="isPlanSelectionCheckoutFlow">


            <div fxFlex="50" fxFlex.lt-md="100" class="first-half" [class.mobile-hidden]="mobileCheckoutStep !== 1">
                <div fxLayout="column" class="form-container1">
                    <div class="form-section">
                        <div class="mobile-back-button-container" *ngIf="isPlanSelectionCheckoutFlow"
                            style="margin-bottom: 16px;">
                            <button mat-button class="calsoft-back-button"
                                (click)="goBackToPlanSelection()"><mat-icon>arrow_back</mat-icon> Back to Plan
                                Selection</button>
                        </div>
                        <form [formGroup]="firstFormGroup">

                            <div class="form-header">
                                <h2>Billing Address</h2>
                                <p class="form-subheader">Used to calculate tax and will appear on billing documents</p>
                            </div>

                            <div class="form-fields">
                                <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
                                    <mat-form-field fxFlex appearance="outline" floatLabel="always">
                                        <mat-label>Billing Name</mat-label>
                                        <input [attr.guide]="'renewal-inp-storename' + '__' + sanitizedUrl" matInput
                                            formControlName="storeName" required />
                                        <mat-error *ngIf="firstFormGroup.controls.storeName.errors?.required">
                                            Please fill out this field.
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
                                    <mat-form-field fxFlex appearance="outline" floatLabel="always">
                                        <mat-label>GST/VAT No</mat-label>
                                        <input [attr.guide]="'renewal-inp-txnid' + '__' + sanitizedUrl" matInput
                                            formControlName="txnId" />
                                    </mat-form-field>
                                </div>

                                <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
                                    <mat-form-field fxFlex appearance="outline" floatLabel="always">
                                        <mat-label>Country</mat-label>
                                        <mat-select required [disableOptionCentering]="true" #singleSelect
                                            formControlName="country" autocomplete="off"
                                            (selectionChange)="onLocationCountryChange($event)">
                                            <mat-option>
                                                <ngx-mat-select-search name="Country Search" ngDefaultControl
                                                    [formControl]="countrySearchControl" placeholderLabel="Search"
                                                    [preventHomeEndKeyPropagation]="true"
                                                    noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let opt of filteredLocationCountries"
                                                [value]="opt.name">
                                                {{opt.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
                                    <mat-form-field fxFlex appearance="outline" floatLabel="always">
                                        <mat-label>Address</mat-label>
                                        <input [attr.guide]="'renewal-inp-address' + '__' + sanitizedUrl" matInput
                                            formControlName="address" required />
                                        <mat-error *ngIf="firstFormGroup.controls.address.errors?.required">
                                            Please fill out this field.
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="form-row" *ngIf="selectedCountryId" fxLayout="row" fxLayout.lt-md="column"
                                    fxLayoutGap="15px">
                                    <mat-form-field fxFlex appearance="outline" floatLabel="always">
                                        <mat-label>State</mat-label>
                                        <mat-select [disableOptionCentering]="true" #singleSelect
                                            formControlName="state" (selectionChange)="onLocationStateChange($event)"
                                            [disabled]="!selectedCountryId || locationStates.length === 0">
                                            <mat-option>
                                                <ngx-mat-select-search ngDefaultControl
                                                    [formControl]="stateSearchControl"
                                                    placeholderLabel="Search state..."
                                                    [preventHomeEndKeyPropagation]="true"
                                                    noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let opt of filteredLocationStates" [value]="opt.name">
                                                {{opt.name}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="firstFormGroup.controls.state.errors?.required">
                                            Please fill out this field.
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="form-row" *ngIf="selectedStateId" fxLayout="row" fxLayout.lt-md="column"
                                    fxLayoutGap="15px">
                                    <mat-form-field fxFlex appearance="outline" floatLabel="always">
                                        <mat-label>City</mat-label>
                                        <mat-select [disableOptionCentering]="true" #singleSelect formControlName="city"
                                            (selectionChange)="onLocationCityChange($event)"
                                            [disabled]="!selectedStateId || locationCities.length === 0">
                                            <mat-option>
                                                <ngx-mat-select-search ngDefaultControl
                                                    [formControl]="citySearchControl" placeholderLabel="Search city..."
                                                    [preventHomeEndKeyPropagation]="true"
                                                    noEntriesFoundLabel="No data found">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let opt of filteredLocationCities" [value]="opt.name">
                                                {{opt.name}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="firstFormGroup.controls.city.errors?.required">
                                            Please fill out this field.
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
                                    <mat-form-field fxFlex appearance="outline" floatLabel="always">
                                        <mat-label>Pincode</mat-label>
                                        <input [attr.guide]="'renewal-inp-pincode' + '__' + sanitizedUrl" matInput
                                            numbersOnly [decimal]="false" formControlName="pincode" required />
                                        <mat-error *ngIf="firstFormGroup.controls.pincode.errors?.required">
                                            Please fill out this field.
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div *ngIf="isNewRoute" class="form-row" fxLayout="row" fxLayout.lt-md="column"
                                    fxLayoutGap="15px">
                                    <mat-form-field fxFlex appearance="outline" floatLabel="always">
                                        <mat-label>Email</mat-label>
                                        <input [attr.guide]="'renewal-inp-email' + '__' + sanitizedUrl" matInput
                                            formControlName="email" required />
                                        <mat-error *ngIf="firstFormGroup.controls.email.errors?.required">
                                            Please fill out this field.
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div *ngIf="isNewRoute" class="form-row" fxLayout="row" fxLayout.lt-md="column"
                                    fxLayoutGap="15px">
                                    <mat-form-field fxFlex appearance="outline" floatLabel="always">
                                        <mat-label>Phone</mat-label>
                                        <input [attr.guide]="'renewal-inp-phone' + '__' + sanitizedUrl" matInput
                                            formControlName="phone" required />
                                        <mat-error *ngIf="firstFormGroup.controls.phone.errors?.required">
                                            Please fill out this field.
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                            </div>
                        </form>
                        <div class="mobile-next-button-container">
                            <button mat-raised-button color="primary" class="full-width-btn"
                                (click)="goToNextMobileStep()">Continue to Checkout</button>
                        </div>
                    </div>
                </div>

            </div>

            <div fxFlex="50" fxFlex.lt-md="100" class="second-half" *ngIf="subscriptionLoaded && accountLoaded"
                [class.mobile-hidden]="mobileCheckoutStep === 1">
                <div fxLayout="column" class="billing-container">
                    <div class="mobile-back-button-container">
                        <button mat-button class="calsoft-back-button"
                            (click)="goToPrevMobileStep()"><mat-icon>arrow_back</mat-icon> Back to Billing</button>
                    </div>

                    <div [class.mobile-hidden]="mobileCheckoutStep !== 2">
                        <div class="billing-section" *ngIf="isPlanSelectionCheckoutFlow">
                            <div class="section-header">
                                <h2>{{ planSelectionSummaryTitle }}</h2>
                            </div>

                            <div class="section-content">
                                <div class="summary-row" fxLayout="row" fxLayoutAlign="space-between center">
                                    <span class="summary-label">Current plan:</span>
                                    <span class="summary-value">{{ upgradeCurrentPlanName }}</span>
                                </div>

                                <div class="summary-row" fxLayout="row" fxLayoutAlign="space-between center">
                                    <span class="summary-label">{{ planSelectionTargetPlanLabel }}</span>
                                    <span class="summary-value">{{ upgradeTargetPlanName }}</span>
                                </div>

                                <div class="summary-row" fxLayout="row" fxLayoutAlign="space-between center">
                                    <span class="summary-label">Billing cycle:</span>
                                    <span class="summary-value">{{ billingCycle }}</span>
                                </div>

                                <div class="summary-row" *ngIf="!isUnlimitedPlan" fxLayout="row"
                                    fxLayoutAlign="space-between center">
                                    <span class="summary-label">Users:</span>
                                    <span class="summary-value">{{ upgradeSelectedUsers }}</span>
                                </div>

                                <div class="summary-row" *ngIf="upgradeSubscriptionStartDate" fxLayout="row"
                                    fxLayoutAlign="space-between center">
                                    <span class="summary-label">Subscription start:</span>
                                    <span class="summary-value">{{ upgradeSubscriptionStartDate }}</span>
                                </div>

                                <div class="summary-row" fxLayout="row" fxLayoutAlign="space-between center">
                                    <span class="summary-label">Current valid till:</span>
                                    <span class="summary-value">{{ upgradeCurrentValidityDate }}</span>
                                </div>

                                <div class="summary-row" fxLayout="row" fxLayoutAlign="space-between center">
                                    <span class="summary-label">{{ planSelectionProjectedValidityLabel }}</span>
                                    <span class="summary-value">{{ upgradeProjectedValidityDate }}</span>
                                </div>

                                <div class="summary-row" fxLayout="row" fxLayoutAlign="space-between center">
                                    <span class="summary-label">{{ planSelectionSubtotalLabel }}</span>
                                    <span class="summary-value">{{ currencySymbol }}{{ computedSubtotal }}</span>
                                </div>

                                <div class="summary-row total-row" fxLayout="row" fxLayoutAlign="space-between center">
                                    <span class="summary-label">Pay now:</span>
                                    <span class="summary-value total-amount">{{ currencySymbol }}{{ computedGrandTotal
                                        }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="billing-section">
                            <div *ngIf="showBillingDetailsHeader" class="section-header" fxLayout="row"
                                fxLayoutAlign="space-between center">
                                <h2>Billing Details</h2>
                                <div *ngIf="!showRenwal" class="info-row">
                                    <span class="info-label">Monthly Price:</span>
                                    <span class="info-value">{{ currencySymbol }}{{ availableMonthlyPrice || 0 }}</span>
                                </div>
                                <div *ngIf="!showRenwal" class="info-row">
                                    <span class="info-label">Annual Price:</span>
                                    <span class="info-value">{{ currencySymbol }}{{ availableAnnualPrice || 0 }}</span>
                                </div>
                                <div class="billing-toggle"
                                    *ngIf="availableMonthlyPrice > 0 || availableAnnualPrice > 0">
                                    <button [attr.guide]="'renewal-btn-1' + '__' + sanitizedUrl" mat-button
                                        [ngClass]="{'selected': billingCycle === 'monthly'}"
                                        [disabled]="availableMonthlyPrice <= 0"
                                        (click)="updatePrice('monthly')">Monthly</button>
                                    <button [attr.guide]="'renewal-btn-3' + '__' + sanitizedUrl" mat-button
                                        [ngClass]="{'selected': billingCycle === 'quarterly'}"
                                        (click)="updatePrice('quarterly')">Quarterly</button>
                                    <button [attr.guide]="'renewal-btn-4' + '__' + sanitizedUrl" mat-button
                                        [ngClass]="{'selected': billingCycle === 'half_yearly'}"
                                        (click)="updatePrice('half_yearly')">Half Yearly</button>
                                    <button [attr.guide]="'renewal-btn-2' + '__' + sanitizedUrl" mat-button
                                        color="primary" [ngClass]="{'selected': billingCycle === 'annually'}"
                                        [disabled]="availableAnnualPrice <= 0"
                                        (click)="updatePrice('annually')">Annually</button>
                                </div>
                            </div>

                            <div *ngIf="showBillingDetailsHeader" class="section-content">
                                <div class="info-row">
                                    <span class="info-label">Billing Cycle:</span>
                                    <span class="info-value">Billed {{ billingCycle }}</span>
                                </div>

                                <div class="info-group">
                                    <h3 class="info-title">Commitment Term</h3>
                                    <div class="info-row">
                                        <span class="info-value">{{ startDate | date:'MMM dd, yyyy' }} - {{ endDate |
                                            date:'MMM dd,
                                            yyyy' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="showProductsSection" class="billing-section">
                            <div class="section-header">
                                <h2>Products</h2>
                            </div>

                            <div class="section-content">
                                <div class="billing-toggle"
                                    *ngIf="subscribtionType == 2 && availableMonthlyPrice > 0 && availableAnnualPrice > 0"
                                    style="margin-bottom:12px;">
                                    <button mat-button [ngClass]="{'selected': billingCycle === 'monthly'}"
                                        (click)="updatePrice('monthly')">Monthly</button>
                                    <button mat-button color="primary"
                                        [ngClass]="{'selected': billingCycle === 'annually'}"
                                        (click)="updatePrice('annually')">Annually</button>
                                </div>
                                <div class="form-row" fxLayout="row" fxLayoutAlign="space-between center">
                                    <div class="user-selector" style="width:100%">
                                        <mat-form-field appearance="outline" floatLabel="always" style="width:100%">
                                            <mat-label>Pricing Plan</mat-label>
                                            <mat-select formControlName="pricingId"
                                                (selectionChange)="onPricingChange()">
                                                <mat-option *ngFor="let plan of pricingList" [value]="plan.pricingId">
                                                    {{plan.planName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="product-row" fxLayout="row" fxLayoutAlign="space-between center">
                                    <div class="product-name"><strong>{{ pricingPreview?.pricingName || 'Starter
                                            Customer
                                            Platform' }}</strong></div>
                                    <div class="product-price" *ngIf="displayPlanPrice > 0">{{ currencySymbol }} {{
                                        displayPlanPrice }}</div>
                                </div>

                                <div class="form-row" *ngIf="shouldShowUsers()&&!showRenwal" fxLayout="row"
                                    fxLayoutAlign="space-between center">
                                    <div class="user-selector">
                                        <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label>Number of Users</mat-label>
                                            <input [attr.guide]="'renewal-inp-users' + '__' + sanitizedUrl"
                                                [readonly]="subscribtionType==2 && !upgradePlantype" matInput
                                                formControlName="users" type="number" min="1" required
                                                (input)="onUsersChanged($event.target.value)" (blur)="onUsersBlur()" />
                                            <mat-error *ngIf="firstFormGroup.controls.users.errors?.required">
                                                Please fill out this field.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="total-price">
                                        <span class="price-label">Total Price:</span>
                                        <span class="price-value">{{ currencySymbol }}{{ computedSubtotal }}</span>
                                    </div>
                                </div>
                                <div class="form-row" *ngIf="!shouldShowUsers()" fxLayout="row"
                                    fxLayoutAlign="end center">
                                    <div class="total-price">
                                        <span class="price-label">Total Price:</span>
                                        <span class="price-value">{{ currencySymbol }}{{ computedSubtotal }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mobile-next-button-container">
                            <button mat-raised-button color="primary" class="full-width-btn"
                                (click)="goToNextMobileStep()">
                                Continue to {{ (billingAddons.length > 0 || billingAddonsLoading) ? 'Add-ons' : 'Order
                                Summary' }}
                            </button>
                        </div>
                    </div>

                    <!-- ================================================================ -->
                    <!-- Add-on Pizza Selector                                          -->
                    <!-- ================================================================ -->
                    <div class="billing-section" *ngIf="billingAddons.length > 0 || billingAddonsLoading"
                        [class.mobile-hidden]="mobileCheckoutStep !== 3">
                        <div class="section-header">
                            <h2>Add-ons
                                <span *ngIf="billingAddonSelections.length > 0"
                                    style="margin-left:8px;background:#1565c0;color:#fff;border-radius:12px;padding:2px 10px;font-size:12px;font-weight:600;vertical-align:middle">
                                    {{ billingAddonSelections.length }} selected
                                </span>
                            </h2>
                            <p style="font-size:12px;color:#888;margin:0">Choose add-ons to include with your
                                subscription</p>
                        </div>

                        <div *ngIf="billingAddonsLoading" style="color:#7b8aa3;font-size:13px;padding:8px 0">
                            Loading add-ons...
                        </div>

                        <!-- PLAN-type add-ons (max 1) -->
                        <ng-container *ngIf="!billingAddonsLoading && planTypeAddonsForBilling.length > 0">
                            <div
                                style="font-size:11px;text-transform:uppercase;letter-spacing:.5px;color:#1565c0;font-weight:700;margin:10px 0 6px">
                                Plan Add-ons &nbsp;<span
                                    style="font-weight:400;color:#aaa;text-transform:none;letter-spacing:0">(pick
                                    1)</span>
                            </div>
                            <div style="display:flex;flex-wrap:wrap;gap:10px;margin-bottom:8px">
                                <div *ngFor="let addon of planTypeAddonsForBilling"
                                    (click)="!isPlanAddonDisabledInBilling(addon) && onToggleBillingAddon(addon, !isAddonSelectedInBilling(addon.addonCode))"
                                    [class.addon-tile-selected]="isAddonSelectedInBilling(addon.addonCode)"
                                    [class.addon-tile-disabled]="isPlanAddonDisabledInBilling(addon)"
                                    class="addon-tile">
                                    <div
                                        style="display:flex;align-items:flex-start;justify-content:space-between;gap:6px">
                                        <div>
                                            <div style="font-weight:600;font-size:13px">{{ addon.addonName }}</div>
                                            <div style="font-size:11px;color:#777;margin-top:2px">
                                                {{ currencySymbol }}{{ getCyclePriceForAddon(addon)?.unitPrice ?? '—'
                                                }}/{{ addon.unitLabel || 'unit' }}
                                                &nbsp;·&nbsp;GST {{ getCyclePriceForAddon(addon)?.gstPercentage ?? 18
                                                }}%
                                            </div>
                                        </div>
                                        <mat-icon style="font-size:18px;width:18px;height:18px;line-height:18px"
                                            [style.color]="isAddonSelectedInBilling(addon.addonCode) ? '#fff' : '#ccc'">
                                            {{ isAddonSelectedInBilling(addon.addonCode) ? 'check_circle' :
                                            'radio_button_unchecked' }}
                                        </mat-icon>
                                    </div>
                                    <ng-container *ngIf="isAddonSelectedInBilling(addon.addonCode)">
                                        <ng-container *ngFor="let sel of billingAddonSelections">
                                            <ng-container *ngIf="sel.addon.addonCode === addon.addonCode">
                                                <div
                                                    style="margin-top:8px;border-top:1px solid rgba(255,255,255,0.3);padding-top:6px;font-size:12px">
                                                    <span style="opacity:.85">Pro-rated: {{ currencySymbol }}{{
                                                        sel.subtotal | number:'1.2-2' }} + GST</span><br>
                                                    <strong>Total: {{ currencySymbol }}{{ sel.total | number:'1.2-2'
                                                        }}</strong>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Other add-ons (RECORD_RESTRICTION etc. — unlimited) -->
                        <ng-container *ngIf="!billingAddonsLoading && otherTypeAddonsForBilling.length > 0">
                            <div
                                style="font-size:11px;text-transform:uppercase;letter-spacing:.5px;color:#444;font-weight:700;margin:10px 0 6px">
                                Other Add-ons
                            </div>
                            <div style="display:flex;flex-wrap:wrap;gap:10px">
                                <div *ngFor="let addon of otherTypeAddonsForBilling"
                                    (click)="onToggleBillingAddon(addon, !isAddonSelectedInBilling(addon.addonCode))"
                                    [class.addon-tile-selected]="isAddonSelectedInBilling(addon.addonCode)"
                                    class="addon-tile">
                                    <div
                                        style="display:flex;align-items:flex-start;justify-content:space-between;gap:6px">
                                        <div>
                                            <div style="font-weight:600;font-size:13px">{{ addon.addonName }}</div>
                                            <div style="font-size:11px;color:#777;margin-top:2px">
                                                {{ currencySymbol }}{{ getCyclePriceForAddon(addon)?.unitPrice ?? '—'
                                                }}/{{ addon.unitLabel || 'unit' }}
                                                &nbsp;·&nbsp;GST {{ getCyclePriceForAddon(addon)?.gstPercentage ?? 18
                                                }}%
                                            </div>
                                        </div>
                                        <mat-icon style="font-size:18px;width:18px;height:18px;line-height:18px"
                                            [style.color]="isAddonSelectedInBilling(addon.addonCode) ? '#fff' : '#ccc'">
                                            {{ isAddonSelectedInBilling(addon.addonCode) ? 'check_circle' :
                                            'radio_button_unchecked' }}
                                        </mat-icon>
                                    </div>
                                    <!-- Quantity spinner when selected -->
                                    <ng-container *ngIf="isAddonSelectedInBilling(addon.addonCode)">
                                        <ng-container *ngFor="let sel of billingAddonSelections">
                                            <ng-container *ngIf="sel.addon.addonCode === addon.addonCode">
                                                <div style="margin-top:8px;border-top:1px solid rgba(255,255,255,0.3);padding-top:6px"
                                                    (click)="$event.stopPropagation()">
                                                    <div style="display:flex;align-items:center;gap:6px">
                                                        <button mat-icon-button
                                                            style="width:24px;height:24px;line-height:24px;background:rgba(255,255,255,0.2);border-radius:50%"
                                                            (click)="onBillingAddonQtyChange(sel, sel.quantity - 1)">
                                                            <mat-icon
                                                                style="font-size:14px;width:14px;height:14px;line-height:14px;color:#fff">remove</mat-icon>
                                                        </button>
                                                        <span
                                                            style="font-weight:700;font-size:14px;min-width:24px;text-align:center">{{
                                                            sel.quantity }}</span>
                                                        <button mat-icon-button
                                                            style="width:24px;height:24px;line-height:24px;background:rgba(255,255,255,0.2);border-radius:50%"
                                                            (click)="onBillingAddonQtyChange(sel, sel.quantity + 1)">
                                                            <mat-icon
                                                                style="font-size:14px;width:14px;height:14px;line-height:14px;color:#fff">add</mat-icon>
                                                        </button>
                                                        <span style="font-size:11px;opacity:.85;margin-left:4px">{{
                                                            addon.unitLabel || 'units' }}</span>
                                                    </div>
                                                    <div style="font-size:12px;margin-top:4px">
                                                        <span style="opacity:.85">Pro-rated: {{ currencySymbol }}{{
                                                            sel.subtotal | number:'1.2-2' }} + GST</span><br>
                                                        <strong>Total: {{ currencySymbol }}{{ sel.total | number:'1.2-2'
                                                            }}</strong>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                        <div class="mobile-next-button-container">
                            <button mat-raised-button color="primary" class="full-width-btn"
                                (click)="goToNextMobileStep()">Continue to Order Summary</button>
                        </div>
                    </div>
                    <!-- end Add-on Pizza Selector -->

                    <div class="billing-section" [class.mobile-hidden]="mobileCheckoutStep !== 4">
                        <div class="section-header">
                            <h2>Order Summary</h2>
                        </div>

                        <div class="section-content">
                            <div class="summary-row" *ngIf="!pendingAddonOnly" fxLayout="row"
                                fxLayoutAlign="space-between center">
                                <span class="summary-label">Billing Cycle:</span>
                                <span class="summary-value">{{ orderSummaryBillingCycle }}</span>
                            </div>

                            <div class="summary-row" *ngIf="!isUnlimitedPlan && !pendingAddonOnly" fxLayout="row"
                                fxLayoutAlign="space-between center">
                                <span class="summary-label">{{ orderSummaryUsersLabel }}:</span>
                                <span class="summary-value">{{ orderSummaryUsers }}</span>
                            </div>

                            <div *ngIf="computedPricePerUser > 0 && !pendingAddonOnly" class="summary-row"
                                fxLayout="row" fxLayoutAlign="space-between center">
                                <span class="summary-label">Price per user:</span>
                                <span class="summary-value">{{ currencySymbol }}{{ computedPricePerUser | number:'1.2-2'
                                    }}</span>
                            </div>

                            <div *ngIf="pendingAddUsers && pendingAddUsers > 0" class="summary-row" fxLayout="row"
                                fxLayoutAlign="space-between center">
                                <span class="summary-label">Additional Users:</span>
                                <span class="summary-value">+{{ pendingAddUsers }}</span>
                            </div>

                            <!-- Addon-only: show each addon as a line item subtotal -->
                            <ng-container *ngIf="pendingAddonOnly">
                                <div *ngFor="let sel of billingAddonSelections" class="summary-row" fxLayout="row"
                                    fxLayoutAlign="space-between center">
                                    <span class="summary-label">
                                        {{ sel.addon.addonName }}<span *ngIf="sel.quantity > 1"> × {{ sel.quantity
                                            }}</span> (pro-rated):
                                    </span>
                                    <span class="summary-value">{{ currencySymbol }}{{ sel.subtotal | number:'1.2-2'
                                        }}</span>
                                </div>
                            </ng-container>

                            <!-- Selected add-ons: shown BEFORE subtotal so subtotal visually includes them -->
                            <ng-container *ngIf="!pendingAddonOnly && billingAddonSelections.length > 0">
                                <div *ngFor="let sel of billingAddonSelections" class="summary-row" fxLayout="row"
                                    fxLayoutAlign="space-between center" style="color:#1565c0;font-size:12px">
                                    <span class="summary-label">
                                        + {{ sel.addon.addonName }}
                                        <span *ngIf="sel.quantity > 1"> × {{ sel.quantity }}</span>
                                        <span *ngIf="isRenewalFromPlanSelection"> (pro-rated)</span>:
                                    </span>
                                    <span class="summary-value">{{ currencySymbol }}{{ sel.subtotal | number:'1.2-2'
                                        }}</span>
                                </div>
                            </ng-container>

                            <div class="summary-row" *ngIf="!pendingAddonOnly" fxLayout="row"
                                fxLayoutAlign="space-between center">
                                <span class="summary-label">{{ orderSummarySubtotalLabel }}:</span>
                                <span class="summary-value">{{ currencySymbol }}{{ computedSubtotal }}</span>
                            </div>

                            <!-- Coupon input -->
                            <div class="summary-row" fxLayout="row" fxLayoutAlign="space-between center"
                                style="gap:8px;margin-top:4px" *ngIf="!appliedCoupon">
                                <input matInput placeholder="Coupon code" [(ngModel)]="couponCodeInput"
                                    [ngModelOptions]="{standalone: true}"
                                    style="flex:1;border:1px solid #ccc;border-radius:4px;padding:6px 10px;font-size:13px;outline:none"
                                    (keydown.enter)="applyCheckoutCoupon()" />
                                <button mat-stroked-button color="primary"
                                    [disabled]="!couponCodeInput || couponApplying" (click)="applyCheckoutCoupon()"
                                    style="font-size:12px;padding:0 10px;min-width:60px">
                                    {{ couponApplying ? '...' : 'Apply' }}
                                </button>
                            </div>
                            <div *ngIf="couponError" style="color:#e53935;font-size:12px;margin-top:2px">{{ couponError
                                }}</div>

                            <!-- Applied coupon row -->
                            <div *ngIf="appliedCoupon" class="summary-row" fxLayout="row"
                                fxLayoutAlign="space-between center" style="color:#2e7d32">
                                <span class="summary-label">
                                    Coupon ({{ appliedCoupon.couponCode }}):
                                    <button mat-icon-button
                                        style="width:20px;height:20px;line-height:20px;vertical-align:middle"
                                        (click)="removeCheckoutCoupon()" title="Remove coupon">
                                        <mat-icon
                                            style="font-size:14px;width:14px;height:14px;line-height:14px">close</mat-icon>
                                    </button>
                                </span>
                                <span class="summary-value" style="color:#2e7d32">-{{ currencySymbol }}{{ couponDiscount
                                    | number:'1.2-2' }}</span>
                            </div>

                            <div class="summary-row" fxLayout="row" fxLayoutAlign="space-between center">
                                <span class="summary-label">GST (18%):</span>
                                <span class="summary-value">{{ currencySymbol }}{{ computedGst }}</span>
                            </div>

                            <div class="summary-row total-row" fxLayout="row" fxLayoutAlign="space-between center">
                                <span class="summary-label">{{ orderSummaryTotalLabel }}:</span>
                                <span class="summary-value total-amount">{{ currencySymbol }}{{ computedGrandTotal
                                    }}</span>
                            </div>
                            <!-- Note row intentionally hidden per UI requirements -->
                            <!-- <div fxLayoutAlign="center center" style="width:100%;">
                        <calsoft-payment [contact]="firstFormGroup.value" [partialAmountEnabled]="0"
                          [type]="2"
                          [form]="firstFormGroup"
                            (paymentStatus)="paymentResponceRazorPAy($event)"
                            [finalAmount]="grandTotal"
                            (valide)="setFormInvalid()"
                            >
                        </calsoft-payment>
                    </div> -->

                            <!-- Note row intentionally hidden per UI requirements -->
                            <!-- ... -->
                        </div>
                        <div class="mobile-next-button-container">
                            <button mat-raised-button color="primary" class="full-width-btn"
                                (click)="goToNextMobileStep()">Continue to Payment</button>
                        </div>
                    </div>

                    <div class="payment-section" [class.mobile-hidden]="mobileCheckoutStep !== 5">

                        <div class="section-header">
                            <h2>Payment</h2>
                        </div>

                        <!-- Razor -->

                        <div class="padding-10">

                            <mat-radio-group formControlName="paymentGateway">


                                <div style="margin-top:15px" *ngIf="currency === 'INR'">

                                    <mat-radio-button [attr.guide]="'renewal-chk-3' + '__' + sanitizedUrl"
                                        value="razor">
                                        Razorpay
                                    </mat-radio-button>

                                    <div class="padding-10"
                                        *ngIf="firstFormGroup.get('paymentGateway')?.value === 'razor'"
                                        style="margin-top:10px">

                                        <calsoft-payment [contact]="firstFormGroup.value" [partialAmountEnabled]="0"
                                            [type]="2" [form]="firstFormGroup" [finalAmount]="computedGrandTotal"
                                            [currency]="currency" (paymentStatus)="paymentResponceRazorPAy($event)"
                                            (valide)="setFormInvalid()">
                                        </calsoft-payment>

                                    </div>

                                </div>


                                <div style="margin-top:20px" *ngIf="currency !== 'INR'">

                                    <mat-radio-button [attr.guide]="'renewal-chk-4' + '__' + sanitizedUrl"
                                        value="stripe">
                                        Stripe
                                    </mat-radio-button>


                                    <div class="padding-10"
                                        *ngIf="firstFormGroup.get('paymentGateway')?.value === 'stripe'"
                                        style="margin-top:10px">

                                        <calsoft-stripe [contact]="firstFormGroup.value" [partialAmountEnabled]="0"
                                            [finalAmount]="computedGrandTotal" [currency]="currency"
                                            [currencySymbol]="currencySymbol"
                                            (paymentStatus)="paymentResponceRazorPAy($event)" [form]="firstFormGroup"
                                            (valide)="setFormInvalid()">
                                        </calsoft-stripe>

                                    </div>

                                </div>

                            </mat-radio-group>
                        </div>


                    </div>




                </div>
            </div>
        </div>
        <!-- render active banner when in upgrade flow as well -->


        <div *ngIf="showSubscriptionBannerSection && !showCheckoutSection">

            <div *ngIf="isSubscriptionManageRoute || !showRenwal">
                <calsoft-renew-active [plan]="plan" [subscriptionSummary]="subscriptionSummary"
                    [currencySymbol]="currencySymbol" [daysRemaining]="daysRemaining"
                    [renewalThresholdDays]="renewalThresholdDays" [canRenew]="canRenew"
                    [loaded]="subscriptionLoaded && accountLoaded" [pricingList]="pricingList"
                    [availableMonthlyPrice]="availableMonthlyPrice" [availableAnnualPrice]="availableAnnualPrice"
                    [pricingPreview]="pricingPreview" [currentUsers]="currentUsers" [isUnlimitedPlan]="isUnlimitedPlan"
                    [isFreePlan]="isFreePlan" [showPaymentOptions]="showPaymentOptions"
                    [upgradePlantype]="upgradePlantype" [hasActiveSubscription]="hasActiveSubscription"
                    (renew)="renewNow()" (changePlan)="onChildChangePlan()"
                    (addUsersProceed)="onChildAddUsersProceed($event)" (addUsers)="onChildAddUsers()"
                    (usersAdded)="onChildUsersAdded($event)" (manageSubscription)="onChildManageSubscription()"
                    (paymentHistory)="onChildPaymentHistory()" (editBilling)="onChildEditBilling()"
                    (changeBillingType)="onChildChangeBillingType($event)"
                    (renewWithAddons)="onChildRenewWithAddons($event)"></calsoft-renew-active>

            </div>
        </div>

        <!-- <div
            *ngIf="!upgradePlantype &&!userNewlyAdded && (subscriptionSummary?.subscriptionActive || hasActiveSubscription)">

 
   
           
            <calsoft-renew-active [plan]="plan" [subscriptionSummary]="subscriptionSummary"
                [daysRemaining]="daysRemaining" [renewalThresholdDays]="renewalThresholdDays" [canRenew]="canRenew"
                [loaded]="subscriptionLoaded && accountLoaded" [pricingList]="pricingList"
                [availableMonthlyPrice]="availableMonthlyPrice" [availableAnnualPrice]="availableAnnualPrice"
                [pricingPreview]="pricingPreview" [currentUsers]="currentUsers" [isUnlimitedPlan]="isUnlimitedPlan"
                [showPaymentOptions]="showPaymentOptions" [upgradePlantype]="upgradePlantype"
                [hasActiveSubscription]="hasActiveSubscription" (renew)="renewNow()" (changePlan)="onChildChangePlan()"
                (addUsers)="onChildAddUsers()" (usersAdded)="onChildUsersAdded($event)"
                (manageSubscription)="onChildManageSubscription()" (paymentHistory)="onChildPaymentHistory()"
                (editBilling)="onChildEditBilling()" (changeBillingType)="onChildChangeBillingType($event)"
                (addUsersProceed)="onChildAddUsersProceed($event)"></calsoft-renew-active>

                

        </div> -->
    </div>

    <!-- Add Users modal moved to renew-active component -->

</div>